
export default function TestimonialsSection() {
  const testimonials = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Marketing Manager",
      company: "Tech Solutions Inc.",
      image: "https://public.readdy.ai/ai/img_res/6d29724de57e30a585e392f2d33a2def.jpg",
      rating: 5,
      text: "The English Learning Academy transformed my career! I went from struggling with presentations to confidently leading international meetings. The business English course was exactly what I needed."
    },
    {
      id: 2,
      name: "Miguel Rodriguez",
      role: "Software Engineer",
      company: "Global Tech Corp",
      image: "https://readdy.ai/api/search-image?query=Professional%20Hispanic%20man%20with%20friendly%20smile%2C%20casual%20business%20attire%2C%20confident%20and%20intelligent%20appearance%2C%20clean%20background&width=100&height=100&seq=testimonial-2&orientation=squarish",
      rating: 5,
      text: "Amazing platform! The one-on-one sessions helped me improve my pronunciation dramatically. My colleagues now understand me perfectly, and I feel much more confident in team discussions."
    },
    {
      id: 3,
      name: "Priya Patel",
      role: "Medical Student",
      company: "University Hospital",
      image: "https://readdy.ai/api/search-image?query=Professional%20Indian%20woman%20with%20warm%20smile%2C%20medical%20student%20appearance%2C%20intelligent%20and%20determined%20look%2C%20clean%20background&width=100&height=100&seq=testimonial-3&orientation=squarish",
      rating: 5,
      text: "The IELTS preparation course was incredible! I scored 8.5 overall and got accepted to my dream medical program. The tutors were patient and really understood my learning needs."
    },
    {
      id: 4,
      name: "Ahmed Hassan",
      role: "Business Owner",
      company: "Hassan Trading LLC",
      image: "https://readdy.ai/api/search-image?query=Professional%20Middle%20Eastern%20businessman%20with%20confident%20smile%2C%20formal%20business%20attire%2C%20successful%20entrepreneur%20appearance%2C%20clean%20background&width=100&height=100&seq=testimonial-4&orientation=squarish",
      rating: 5,
      text: "Excellent investment for my business! Learning English opened up international opportunities. The flexible scheduling worked perfectly with my busy entrepreneur lifestyle."
    },
    {
      id: 5,
      name: "Elena Volkov",
      role: "University Professor",
      company: "International University",
      image: "https://readdy.ai/api/search-image?query=Professional%20Eastern%20European%20woman%20with%20academic%20appearance%2C%20intelligent%20and%20scholarly%20look%2C%20professional%20attire%2C%20clean%20background&width=100&height=100&seq=testimonial-5&orientation=squarish",
      rating: 5,
      text: "As an academic, I needed perfect English for research publications. The advanced writing course helped me publish in top-tier journals. Highly recommend for professionals!"
    },
    {
      id: 6,
      name: "David Kim",
      role: "High School Student",
      company: "International School",
      image: "https://readdy.ai/api/search-image?query=Young%20Asian%20male%20student%20with%20bright%20smile%2C%20casual%20student%20attire%2C%20enthusiastic%20and%20motivated%20appearance%2C%20clean%20background&width=100&height=100&seq=testimonial-6&orientation=squarish",
      rating: 5,
      text: "Started as a complete beginner and now I'm fluent! The interactive lessons made learning fun. I even made friends in the conversation practice groups. Best decision ever!"
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i 
        key={index} 
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-500`}
      ></i>
    ));
  };

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Students Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of successful students who have achieved their English learning goals with our expert guidance and proven methods.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                  <p className="text-xs text-gray-500">{testimonial.company}</p>
                </div>
              </div>
              
              <div className="flex mb-3">
                {renderStars(testimonial.rating)}
              </div>
              
              <p className="text-gray-700 leading-relaxed">"{testimonial.text}"</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Ready to Join Our Success Stories?
          </h3>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
            Start your English learning journey today and become our next success story. 
            With expert tutors and proven methods, your goals are within reach.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-rocket-line mr-2"></i>
              Start Learning Now
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-chat-3-line mr-2"></i>
              Talk to an Advisor
            </button>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">10,000+</div>
              <div className="text-gray-600">Happy Students</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-600 mb-2">4.9/5</div>
              <div className="text-gray-600">Average Rating</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-purple-600 mb-2">95%</div>
              <div className="text-gray-600">Success Rate</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-orange-600 mb-2">50+</div>
              <div className="text-gray-600">Expert Tutors</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
